// Adds any checked .product-upsell__checkbox items to the cart right after
// the main product form's own add-to-cart request succeeds. Kept separate
// from product-form.js (shared by every product form on the theme) rather
// than teaching that file about a feature only some products use - this
// just listens for the cart-update event it already publishes.
(function () {
  function addCheckedUpsells(sectionRoot, cart) {
    var checked = sectionRoot.querySelectorAll('.product-upsell__checkbox:checked');
    if (!checked.length) return;

    var items = Array.prototype.map.call(checked, function (input) {
      return { id: input.value, quantity: 1 };
    });

    var body = { items: items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-upsells',
            errors: response.errors || response.description,
            message: response.message,
          });
          return;
        }
        if (cart) cart.renderContents(response);
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
    if (!data || data.source !== 'product-form' || !data.productVariantId) return;

    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (sectionRoot) {
      var variantInput = sectionRoot.querySelector('.product-variant-id');
      if (!variantInput || variantInput.value !== String(data.productVariantId)) return;
      if (!sectionRoot.querySelector('.product-upsell__checkbox')) return;

      addCheckedUpsells(sectionRoot, document.querySelector('mini-cart'));
    });
  });
})();
